import {GenderEnum} from 'domain/usecases/others/selection-flow/beneficiary-v3';

export function formatGender(gender: GenderEnum) {
	const genderFormatted =
		gender === GenderEnum.FEMALE || gender === GenderEnum.WOMAN
			? GenderEnum.FEMALE
			: GenderEnum.MALE;

	return genderFormatted;
}
